export default {
  hero_label: 'SERVICE',
  hero_title_en: 'AIX Consulting',
  hero_title_ja: 'AIX コンサルティング',
  hero_desc: 'AI戦略の立案からDX推進・新規AI事業の立ち上げまで、\n企業変革のあらゆるフェーズをトータルでご支援します。',
  overview_label: 'OVERVIEW',
  overview_title: 'サービス概要',
  overview_desc: 'AIX Consultingは、「AI」と「あらゆる事業領域（X）」を掛け合わせ、企業の変革と持続的成長を実現するトータルコンサルティングサービスです。\n\n単なるAIツール導入にとどまらず、経営戦略レベルでのAI活用設計から現場定着まで一貫してサポート。上流の戦略立案から下流の実行支援まで、すべてのフェーズで専任のコンサルタントが伴走し、確かな成果につなげます。',
  services_label: 'SERVICES',
  services_title: '主なサービス内容',
  service_1_title: 'AI戦略立案',
  service_1_desc: '自社の事業課題・競合環境・データ資産を分析し、最適なAI活用戦略を設計。短期・中長期のロードマップまで一貫して策定します。',
  service_2_title: 'DX推進支援',
  service_2_desc: '業務フローの可視化からAI・デジタルツールの選定・導入まで、現場に根付いたDX推進を経験豊富なコンサルタントが伴走サポートします。',
  service_3_title: '新規AI事業立ち上げ',
  service_3_desc: 'AIを活用した新規事業の企画・検証・立ち上げを全フェーズで支援。市場調査からPoC設計、事業化まで一気通貫で対応します。',
  service_4_title: 'ROI最大化支援',
  service_4_desc: 'AI投資の効果を可視化し、継続的な改善サイクルを構築。KPI設計から効果測定・改善まで、ROIを最大化するための仕組みを整えます。',
  challenges_label: 'CHALLENGES',
  challenges_title: 'こんな課題を解決します',
  challenge_1: 'AI戦略の立案ができない・何から始めたらいいかわからない',
  challenge_2: 'DX推進が社内で進まず形骸化している',
  challenge_3: '競合他社に比べてAI活用が遅れていると感じている',
  challenge_4: 'AI導入を検討しているが投資対効果が見えない',
  challenge_5: '既存事業にAIを掛け合わせた新規展開を模索している',
  challenge_6: '経営層・現場双方を巻き込んだ変革が難しい',
  reasons_label: 'WHY AIX JAPAN',
  reasons_title: 'AIX JAPANが選ばれる理由',
  reason_1_title: '経営〜現場まで一気通貫',
  reason_1_desc: '戦略策定から現場定着まで、すべてのフェーズで同一チームが責任を持って支援します。分断なき伴走が確かな成果を生みます。',
  reason_2_title: '業界横断の豊富な知見',
  reason_2_desc: '製造・金融・小売・医療など多様な業種での実績をもとに、業界の常識にとらわれない最適なAI活用戦略を設計します。',
  reason_3_title: '成果にコミットする姿勢',
  reason_3_desc: 'KPIの設計から効果測定まで、成果を数字で示す文化が私たちの強みです。「導入すること」ではなく「成果を出すこと」にこだわります。',
  reason_4_title: '専任チームの伴走モデル',
  reason_4_desc: 'プロジェクトごとに専任チームを編成し、一社一社に寄り添った伴走支援を提供。長期的なパートナーシップを大切にします。',
  flow_label: 'FLOW',
  flow_title: '導入の流れ',
  flow_intro: '初回のご相談から継続改善まで、各ステップの作業内容と成果物を明確にして進めます。期間はプロジェクト規模により変動するため、あくまで目安です。',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-chat-3-line',
      title: '現状ヒアリング・課題整理',
      note: '無料',
      duration: '約1〜2週間',
      activities: [
        '事業課題・業務フロー・データ資産・既存システムの棚卸しヒアリング',
        'AI活用余地の初期仮説づくり（「何から始めるべきか分からない」段階で構いません）',
      ],
      deliverables: ['課題整理サマリ', 'AI活用テーマ候補リスト'],
      clientAsks: ['キーパーソンへのヒアリング時間（1〜2時間×数回）', '既存資料（業務フロー・組織図等）の共有'],
    },
    {
      no: '02',
      icon: 'ri-compass-3-line',
      title: 'AI戦略設計・ロードマップ策定',
      duration: '約2〜4週間',
      activities: [
        '優先テーマの選定と投資対効果の試算',
        '短期・中長期ロードマップの設計と経営層向け報告会',
      ],
      deliverables: ['AI活用戦略書', '導入ロードマップ', '概算の投資対効果試算'],
      clientAsks: ['経営層レビュー会へのご参加', '優先順位の意思決定'],
    },
    {
      no: '03',
      icon: 'ri-flask-line',
      title: 'PoC・実行伴走',
      duration: '約1〜3ヶ月',
      activities: [
        '小さく実証するPoCの設計・実施と精度・効果の実測',
        'ツール・ベンダー選定支援、現場への導入・定着支援',
      ],
      deliverables: ['PoC結果報告書（実測値ベース）', '本格導入の判断材料'],
      clientAsks: ['検証用データ・サンプルのご提供', '現場担当者のテスト参加'],
    },
    {
      no: '04',
      icon: 'ri-line-chart-line',
      title: '効果測定・継続改善',
      duration: '継続（月次）',
      activities: [
        'KPIに基づく効果検証と改善サイクルの運用',
        '次テーマへの展開設計・内製化の支援',
      ],
      deliverables: ['月次レポート', '改善・展開のご提案'],
      clientAsks: ['定例レビュー会（月1回程度）へのご参加'],
    },
  ],
};